let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("3lC3S")]).then(() => parcelRequire('3mMPp'));